module.exports = __webpack_public_path__ + "img/client-almokawloon-alarab.12dc8ca1.jpeg";